import React, { useState, useEffect } from "react";
import AdminHead from "./AdminHead";
import { db, storage } from "../Components/Firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import "../Styles/Admin/Docs.css";
import { useParams } from "react-router-dom";

function Docs() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  const { SUID } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    files: [],
  });

  const [previews, setPreviews] = useState([]);
  const [editId, setEditId] = useState(null);

  const loadDocs = async () => {
    setLoading(true);
    try {
      const docsQuery = query(collection(db, "Docs"), where("SUID", "==", SUID));
      const snapshot = await getDocs(docsQuery);
      const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setDocs(list);
    } catch (err) {
      console.error("Error loading docs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDocs();
  }, [SUID]);

  const handleFilesChange = (files) => {
    const fileArray = Array.from(files);
    setFormData({ ...formData, files: fileArray });
    setPreviews(fileArray.map(f => f.name));
  };

  const uploadFile = async (file) => {
    if (!file) return null;
    const storageRef = ref(storage, `Docs/${Date.now()}_${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let uploadedUrls = [];

    for (let file of formData.files) {
      if (typeof file !== "string") {
        const url = await uploadFile(file);
        uploadedUrls.push(url);
      } else {
        uploadedUrls.push(file);
      }
    }

    const dataToSave = {
      name: formData.name,
      files: uploadedUrls,
      SUID: SUID,
      CreatedAt: serverTimestamp(), // Add server timestamp
    };

    if (editId) {
      await updateDoc(doc(db, "Docs", editId), dataToSave);
    } else {
      await addDoc(collection(db, "Docs"), dataToSave);
    }

    setFormData({ name: "", files: [] });
    setPreviews([]);
    setEditId(null);
    loadDocs();
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "Docs", id));
    loadDocs();
  };

  const handleDeleteFile = async (fileUrl) => {
    try {
      const storagePath = decodeURIComponent(fileUrl.split("/o/")[1].split("?")[0]);
      const fileRef = ref(storage, storagePath);
      await deleteObject(fileRef);

      setFormData({
        ...formData,
        files: formData.files.filter(f => f !== fileUrl),
      });
      setPreviews(previews.filter(p => p !== fileUrl.split('/').pop()));
    } catch (err) {
      console.error("Error deleting file:", err);
    }
  };

  const handleEdit = (docItem) => {
    setEditId(docItem.id);
    setFormData({
      name: docItem.name,
      files: docItem.files || [],
    });
    setPreviews(docItem.files?.map(f => f.split("/").pop()) || []);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <React.Fragment>
      <AdminHead />

      <div className="docs-container">
        <form className="doc-form" onSubmit={handleSubmit}>
          <h2>{editId ? "עריכת מסמך" : "הוספת מסמך חדש"}</h2>

          <input
            type="text"
            placeholder="שם המסמך"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />

          <label className="file-input">
            העלאת קבצים
            <input
              type="file"
              multiple
              onChange={(e) => handleFilesChange(e.target.files)}
            />
          </label>

          {previews.length > 0 && (
            <div className="preview-files">
              {previews.map((name, idx) => (
                <div key={idx} className="preview-file">
                  <span>{name}</span>
                  {editId && (
                    <button type="button" onClick={() => handleDeleteFile(formData.files[idx])}>
                      מחק
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}

          <button className="submit-btn" type="submit">
            {editId ? "עדכן" : "צור מסמך"}
          </button>
        </form>

        <h2 className="title">מסמכים</h2>
        {loading ? (
          <p>טוען...</p>
        ) : (
          <div className="docs-grid">
            {docs.map((docItem) => (
              <div className="doc-card" key={docItem.id}>
                <h3>{docItem.name}</h3>
                {docItem.CreatedAt && (
                  <p className="created-at">
                    {new Date(docItem.CreatedAt.seconds * 1000).toLocaleString("he-IL")}
                  </p>
                )}
                <ul>
                  {docItem.files.map((f, idx) => (
                    <li key={idx}>
                      <a href={f} target="_blank" rel="noopener noreferrer">
                        {f.split("/").pop()}
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="card-buttons">
                  <button onClick={() => handleEdit(docItem)}>ערוך</button>
                  <button className="delete-btn" onClick={() => handleDelete(docItem.id)}>מחק</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default Docs;
